export const CURRENCIES = [
  { code: 'USD', name: 'US Dollar' },
  { code: 'ZAR', name: 'South African Rand' },
  { code: 'GBP', name: 'British Pound' },
  { code: 'EUR', name: 'Euro' },
  { code: 'CAD', name: 'Canadian Dollar' },
  { code: 'AUD', name: 'Australian Dollar' },
  { code: 'NZD', name: 'New Zealand Dollar' },
  { code: 'AED', name: 'UAE Dirham' },
  { code: 'SAR', name: 'Saudi Riyal' },
  { code: 'NGN', name: 'Nigerian Naira' },
  { code: 'KES', name: 'Kenyan Shilling' },
  { code: 'INR', name: 'Indian Rupee' },
  { code: 'SGD', name: 'Singapore Dollar' },
  { code: 'HKD', name: 'Hong Kong Dollar' },
  { code: 'JPY', name: 'Japanese Yen' },
  { code: 'CHF', name: 'Swiss Franc' },
  { code: 'SEK', name: 'Swedish Krona' },
  { code: 'NOK', name: 'Norwegian Krone' },
  { code: 'DKK', name: 'Danish Krone' },
  { code: 'PLN', name: 'Polish Zloty' },
  { code: 'MXN', name: 'Mexican Peso' },
  { code: 'BRL', name: 'Brazilian Real' },
  { code: 'CNY', name: 'Chinese Yuan' },
  { code: 'KRW', name: 'South Korean Won' },
  { code: 'THB', name: 'Thai Baht' },
  { code: 'MYR', name: 'Malaysian Ringgit' },
  { code: 'IDR', name: 'Indonesian Rupiah' },
  { code: 'PHP', name: 'Philippine Peso' },
  { code: 'ILS', name: 'Israeli New Shekel' },
  { code: 'TRY', name: 'Turkish Lira' },
] as const;

export type CurrencyCode = (typeof CURRENCIES)[number]['code'];

export const OPTIONAL_FRACTION_DIGITS = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
} satisfies Intl.NumberFormatOptions;

export function formatMoney(
  value: number | string | null | undefined,
  currency: string,
  options: Intl.NumberFormatOptions = {}
): string {
  const parsed = value == null ? 0 : Number(value);
  const amount = Number.isFinite(parsed) ? parsed : 0;
  const minimumFractionDigits =
    options.minimumFractionDigits ?? Math.min(2, options.maximumFractionDigits ?? 2);
  const maximumFractionDigits =
    options.maximumFractionDigits ?? Math.max(2, minimumFractionDigits);
  const isNegative = amount < 0 || Object.is(amount, -0);
  const formatted = new Intl.NumberFormat('en-US', {
    ...options,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(Math.abs(amount));
  const result = currency === 'USD' ? `$${formatted}` : `${currency} ${formatted}`;
  return isNegative ? `-${result}` : result;
}

export { useOrgCurrency } from '@/hooks/use-settings';
